import React from 'react';
import styles from './Toast.module.css';
import InfoIcon from 'assets/icons/infoFill.svg?react';
import CheckIcon from 'assets/icons/check.svg?react';
import CloseIcon from 'assets/icons/close.svg?react';
import type { ToastType } from 'contexts/ToastContext';

type ToastProps = {
    type: ToastType;
    message?: string;
    title?: string;
    dismissible?: boolean;
    onDismiss: () => void;
};

function Toast({ type, message, title, dismissible, onDismiss }: ToastProps): JSX.Element {
    return (
        <article className={`${styles.toast} ${styles[type]} ${dismissible ? styles.dismissible : ''}`} role="alert">
            <div className={styles.content}>
                {title && (
                    <div className={styles.titleWrapper}>
                        {type === 'success' ? <CheckIcon /> : <InfoIcon />}
                        <span className={styles.title}>{title}</span>
                    </div>
                )}
                {message && <span className={styles.message}>{message}</span>}
            </div>

            {dismissible && (
                <button className={styles.closeButton} aria-label="Close" onClick={onDismiss}>
                    <CloseIcon />
                </button>
            )}
        </article>
    );
}

export default Toast;
